module.exports = __webpack_public_path__ + "img/3DTitle.acaed601.png";